// Vue 3 应用入口文件
import { createApp } from 'vue'
import App from './App.vue'

/* 路由 */
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
/* Element Plus 主题覆盖 */
import './assets/css/element-plus-theme.css'

/* axios */

/* Bootstrap 3 CSS */
import 'bootstrap/dist/css/bootstrap.css'

/* swiper 正确的CSS导入 */
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/effect-fade'

/* animate.css */
import 'animate.css'

/* 轻量级图标 */
import './assets/css/icons.css'
/* 重置样式 */
import './assets/css/reset.min.css'
/* 全局样式修复 */
import './assets/css/global.css'

/* 头部组件 */
import Header from './components/AppHeader.vue'

/* 尾部组件 */
import Footer from './components/AppFooter.vue'

/* 回到顶部 */
import GoTop from './components/GoTop.vue'

/* 地图插件 */
import L from "leaflet"
import "leaflet/dist/leaflet.css"

// 创建Vue 3应用实例
const app = createApp(App)

// 使用插件
app.use(ElementPlus)
app.use(router)

// 注册全局组件
app.component('Header', Header)
app.component('Footer', Footer)
app.component('GoTop', GoTop)

// 路由守卫
router.beforeEach((to, from, next) => {
    if(to.meta.title){
      document.title = to.meta.title
    }
    if (to.path === from.path && JSON.stringify(to.query) === JSON.stringify(from.query)) {
      next(false); // 阻止重复导航
    } else {
      next();
    }
});

// 挂载应用
app.mount('#app')
